import React from "react";
import { useT, useI18n } from "@/context/I18nContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageToggle() {
  const t = useT();
  const { lang, setLang } = useI18n();
  const label = lang === "nl" ? "NL" : "EN";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-toggle-trigger"
        className="inline-flex items-center gap-2 rounded-full border border-border bg-white/60 backdrop-blur px-3 py-1.5 text-sm text-ink-700 hover:bg-white hover:shadow-card transition"
        aria-label={t("common.language")}
      >
        <Globe className="h-4 w-4" strokeWidth={1.75} />
        <span className="font-medium">{label}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl">
        <DropdownMenuItem
          data-testid="lang-option-en"
          onSelect={() => setLang("en")}
          className="rounded-lg"
        >
          {t("common.english")}
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="lang-option-nl"
          onSelect={() => setLang("nl")}
          className="rounded-lg"
        >
          {t("common.dutch")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
